import styled from "styled-components";

import ErrorComponent from "components/app/Error/ErrorComponent";
import { API_STATUS_CODES } from "legacy/constants/ApiConstants";
import { STATUS_PAGE } from "pages/routes";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: calc(100vh - ${(props) => props.theme.legacy.headerHeight});
  .bold-text {
    font-weight: ${(props) => props.theme.legacy.fontWeights[3]};
    font-size: 24px;
  }
  .page-unavailable-img {
    width: 35%;
  }
  .button-position {
    margin: auto;
  }
`;

const ServerTimeout = () => {
  return (
    <Wrapper>
      <ErrorComponent
        errorCode={API_STATUS_CODES.TIMEOUT}
        title="Something went wrong. Our team is on it!"
        errorMessage={
          <>
            <span>
              {"The server seems to have timed out. Please try again, see "}
            </span>
            <a href={STATUS_PAGE} target="_blank" rel="noreferrer">
              Status Page
            </a>
          </>
        }
      />
    </Wrapper>
  );
};

export default ServerTimeout;
